<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col">
                <h1 class="text-center py-4">
                    404 page not found
                </h1>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "not-found-component"
    }
</script>

<style scoped>

</style>
